import { Box, Tooltip, tooltipClasses } from '@mui/material';
import React from 'react';
import { styled } from '@mui/system';
import * as S from './styled';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}));

const TrackingStep = ({
  stepTitle,
  hourText,
  icon: Icon,
  toolTipContent,
  disabled
}) => {
  return toolTipContent ? (
    <HtmlTooltip title={toolTipContent}>
      <Box
        style={{
          display: 'flex',
          maxWidth: 200,
          height: '100%',
          padding: 4,
          textAlign: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: 2
        }}
      >
        {Icon && <Icon />}
        {stepTitle && (
          <S.StepTitle disabled={disabled}>{stepTitle}</S.StepTitle>
        )}
        {hourText && <S.HourText>{hourText}</S.HourText>}
      </Box>
    </HtmlTooltip>
  ) : (
    <Box
      style={{
        display: 'flex',
        maxWidth: 200,
        height: '100%',
        padding: 4,
        textAlign: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 2
      }}
    >
      {Icon && <Icon />}
      {stepTitle && <S.StepTitle>{stepTitle}</S.StepTitle>}
      {hourText && <S.HourText>{hourText}</S.HourText>}
    </Box>
  );
};

export default TrackingStep;
